import cx from 'classnames'
import { useFadingScrollbar } from 'hooks/useFadingScrollbar'
import { useRef } from 'react'
import Styles from './ExpandedTOC.module.scss'
import { useActiveHeadingIndex } from './useActiveHeadingIndex'
import { useDocHeadings } from './useDocHeadings'

export const ExpandedTOC = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  useFadingScrollbar(containerRef.current)

  const activeHeadingIndex = useActiveHeadingIndex()
  const headingNodes = useDocHeadings()

  return (
    <div className={Styles.container} ref={containerRef}>
      <ul>
        {headingNodes.map((node, index) => (
          <li key={`${node.attrs.blockId}+${index}`}>
            <a
              className={cx(Styles[`h${node.attrs.level}`], { [Styles.active]: index === activeHeadingIndex })}
              href={`#${node.attrs.blockId}`}
            >
              {node.textContent}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
